export default "__VITE_ASSET__FHdk1zWX__"